import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { Controller, useController, useFormContext } from 'react-hook-form';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';

const RHFDateTimePicker = ({
  name,
  label,
  options,
  spacing,
  helperText,
  children,
  disableFuture,
  ...other
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <FormControl error={!!error} fullWidth={other?.fullWidth}>
          {label && <FormLabel>{label}</FormLabel>}
          <DateTimePicker
            {...field}
            slotProps={{
              textField: {
                fullWidth: true,
              },
            }}
            sx={{
              ...(other?.controlStyle || {}),
            }}
            disableFuture={disableFuture}
          />
          {error && <FormHelperText sx={{ ml: 1 }}>{error?.message ?? helperText}</FormHelperText>}
        </FormControl>
      )}
      {...other}
    >
      {children}
    </Controller>
  );
};

export default RHFDateTimePicker;
